<!--
 * @Description: 人员详情组件
 * @Author: wanqian
 * @Date: 2022-03-16 16:43:52
-->
<template>
   <div class="body">
      <el-dialog class="dialog-attendant" width="1000px" :title="dialogTitle" :visible.sync="visible" 
        :close-on-click-modal="false" @open="initData" :before-close='handleCancel' center>
        <!--status 审核状态：0-未审核 1-审核通过 2-审核拒绝 3-撤回	 审核状态是通过/拒绝时显示审核结果组件-->
        <div class="bk-review-result" v-if="attendantDo && attendantDo.review 
          && (attendantDo.review.status == 1 || attendantDo.review.status == 2)">
          <review-result :review="attendantDo.review" />
        </div>
        <el-steps :active="active" finish-status="success" align-center >
          <el-step title="基本信息" :status="stepStatus(0)"></el-step>
          <el-step title="执业信息" :status="stepStatus(1)"></el-step>
          <el-step title="服务授权" :status="stepStatus(2)"></el-step>
        </el-steps>
        <div class="dialog-body">
          <baseinfo-panel v-if="active == 0" @panel-operate="handlePanelOperate"/>
          <practiceinfo-panel v-if="active == 1" @panel-operate="handlePanelOperate"/>
          <serviceauthorization-panel v-if="active == 2" @panel-operate="handlePanelOperate"/>
        </div>
      </el-dialog>
   </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import attendantStore from './attendantdetails/AttendantStore.js'
import AttendantBaseInfoPanel from './attendantdetails/AttendantBaseInfoPanel.vue'
import PracticeInfoPanel from "./attendantdetails/AttendantPracticeInfoPanel.vue";
import ServiceAuthorizationPanel from "./attendantdetails/AttendantServiceAuthorizationPanel.vue";
import ReviewResult from './attendantdetails/AttendantReviewResult.vue'

export default {
  name: 'AttendantForm',
  props: ["visible", "operate", "attendantId", "institutionId"],
  attendantStore,

  components: {
    'baseinfo-panel': AttendantBaseInfoPanel,
    'practiceinfo-panel': PracticeInfoPanel,
    'serviceauthorization-panel': ServiceAuthorizationPanel,
    'review-result': ReviewResult,
  },

  data() {
    return {
      active: 0,
      attendantDo: null,
    }
  },

  computed: {
    dialogTitle() {
			switch (this.operate) {
        case 'add'    : return "新增人员";
        case 'edit'   : return "编辑人员";
        case 'details': return "人员详情";
        default       : return "----";
      } 
    },

		stepStatus() {
      return function(curActive) {
        return (curActive <= this.active) ? 'finish' : 'wait';
      }
    },
  },
  
  methods:{
    initData() {
      this.clearData();
			attendantStore.commit("changeMode", this.operate);
      this.active = 0;
      this.queryData();
    },

    queryData() {
      let url = this.operate == 'add' ? Constant.URL_GET_ATTENDANT_DO_4_ADD : Constant.URL_GET_ATTENDANT_DO_4_UPDATE;
      let params = this.operate == 'add' ? {} : {'id': this.attendantId};
      let header = this.encryptionUtil.signatureParams(params, 
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: url,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.attendantDo = result.data;
          this.$set(this.attendantDo.attendant, 'area', 
            [this.attendantDo.attendant.provinceId,this.attendantDo.attendant.cityId]);
          attendantStore.commit('changeAttendantPrivilege', {canReview: false});
          attendantStore.commit('changeAttendant', JSON.parse(JSON.stringify(this.attendantDo.attendant)));
          if (this.operate == "add") {
            attendantStore.commit('changeAttendantDo', JSON.parse(JSON.stringify(this.initDataAddDo(this.attendantDo))));
          } else {
            attendantStore.commit('changeAttendantDo', 
              JSON.parse(JSON.stringify(this.initDataEditDoOrDetails(this.attendantDo))));
          }   
        }
      })
    },

    initDataAddDo(obj) {
      //处理新增DO里面数据
      //新增里面选项带ID的属性返回的是0，显示应该为空,带数据结构的列表数组置空
      let result = obj;
      if (!result.attendant.institutionId || result.attendant.institutionId == 0) {
        result.attendant.institutionId = "";
      }
      if (this.institutionId) result.attendant.institutionId = this.institutionId;
      result.attendant.provinceId = '';
      result.attendant.cityId = '';
      result.attendant.level = "";
      result.attendant.gender = "";
      result.attendant.privilegeList = [];
      this.$set(this.attendantDo.attendant, 'age', '');
      this.$set(this.attendantDo.attendant, 'attendantAge', '');
      //将机构全部选项改为不能选
			let institutionList = result.institutionList;
			institutionList.forEach(element => {
        if (element.name == "全部" || element.id == 0) {
          element.disabled = true;
        }
			});
      result.institutionList = institutionList;
      return result;
    },

    initDataEditDoOrDetails(obj) {
      let result = obj;
      if (!result.attendant.institutionId || result.attendant.institutionId == 0 ) {
        result.attendant.institutionId = "";
      }
      if (!result.attendant.level || result.attendant.level == 0) {
        result.attendant.level = "";
      }
      let age = this.commonUtil.calcAgeFromIdNo(obj.attendant.idCardNo);
      this.$set(result.attendant, 'age', age);
      let attendantAge = (obj.attendant && obj.attendant.practiceStartDate) 
        ? this.dateUtil.yearsAgoText(obj.attendant.practiceStartDate, new Date()) : "";
      this.$set(this.attendantDo.attendant, 'attendantAge', attendantAge);
      if (!result.attendant.privilegeList) {
        result.attendant.privilegeList = [];
      }
      return result;
    },

    handlePanelOperate(opr) {
      switch(opr) {
        case 'prev': 
          this.handlePrev();
          break;
        case 'next':
          this.handleNext();
          break;
        case 'ok':
          this.handleCancel();
          break;
        case 'add':
        case 'edit':
          this.handleSubmit(opr);
          break;
        case 'cancel':
          this.handleCancel();
          break;
      }
    },

		handlePrev() {
      if (this.active > 0) this.active--;
    },

    handleNext() {
      if (this.active == 0 && attendantStore.state.isIdNoRepeat) {
        this.$message.error('该机构下该人员身份证号已占用');
        return;
      }
      if (this.active < 3) this.active++;
    },

		handleSubmit(_opr) {      
      let url = (this.operate == 'add') ? Constant.URL_SAVE_ATTENDANT : Constant.URL_UPDATE_ATTENDANT;
      let attendantDo = JSON.parse(JSON.stringify(attendantStore.state.attendantDo));
      let attendant = this.rebuildSubmitAttendant(attendantDo.attendant);
      let fileMap = new Map();
      if (attendantStore.state.idCardImgFrontFile && attendantStore.state.idCardImgFrontFile.raw) {
        fileMap.set('idCardImg1File', attendantStore.state.idCardImgFrontFile.raw);
      }
      if (attendantStore.state.idCardImgBackFile && attendantStore.state.idCardImgBackFile.raw) {
        fileMap.set('idCardImg2File', attendantStore.state.idCardImgBackFile.raw);
      }
      let params = {'name': 'attendant', 'value': {...attendant}};
      let [header, esParams] = this.encryptionUtil.encryptAndSignObjectParam(
				params, Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY, 
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        url: url,
        method: (this.operate == 'add') ? 'POST' : 'PUT',
        contentType: this.commonConst.CNTYPE_JSON,
        header: header,
        param: esParams,
        files: fileMap
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.clearData();
          this.$emit("close-dialog", true);
        }
      })    
    },

    rebuildSubmitAttendant(attendant) {
      attendant.provinceId = attendant.area[0];
      attendant.cityId = attendant.area[1];
      this.$delete(attendant, 'area');
      this.$delete(attendant, 'age');
      this.$delete(attendant, 'attendantAge');
      return attendant;
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    clearData() {
      this.active = 0;
      attendantStore.commit('changeIdCardImgFrontFile', null);
      attendantStore.commit('changeIdCardImgBackFile', null);
      attendantStore.commit('changeAttendant', {});
      attendantStore.commit('changeAttendantDo', {attendant: {},});
      attendantStore.commit('changeIsIdNoRepeat', false);
    }
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.bk-review-result {
  margin: 10px 25px 34px 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/AttendantForm.vue